/**
 * @file: PrecutBar.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 校方条码管理
 */
import request from '@/utils/request'

/**
 * 批量删除预制条码(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function precutbarBatchDelete(data) {
  return request({
    type: 'biz',
    url: 'precutbar/batch/delete',
    method: 'post',
    data
  })
}

/**
 * 根据条码获取预制条码列表(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function precutbarListGet(data) {
  return request({
    type: 'biz',
    url: 'precutbar/list/get',
    method: 'post',
    data
  })
}

/**
 * 分页获取预制条码列表(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function precutbarPageListGet(data) {
  return request({
    type: 'biz',
    url: 'precutbar/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 将条形码导出成word文档(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function precutbarWordGet(data) {
  return request({
    type: 'biz',
    url: 'precutbar/word/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/PrecutBar.js